<div class="container text-center">
  <h1>{{"WELCOME_DETAIL.SELECT" | translate}}</h1>
  <div  class="card p-6 flex-1 flex flex-col items-center subCards" *ngFor="let program of programs">
    <img [src]="environment+'/'+program.id+'/'+'images/main'" alt="" class="programs" (click)="programInfo(program)">
  </div>
</div>
